/**
 * ShareErrorPage - Error page for invalid or unavailable share links.
 */

import { LinkBroken01 } from '@untitledui/icons';

import { useAuthStatus } from '@/allauth_auth/hooks.js';

export interface ShareErrorPageProps {
  /** Error message to display (kept for backward compatibility) */
  message?: string;
}

export function ShareErrorPage({ message: _message }: ShareErrorPageProps) {
  const [, { isAuthenticated }] = useAuthStatus();
  return (
    <div className='min-h-full bg-bg-primary flex flex-col'>
      {/* Header */}
      <header className='border-b border-border-secondary px-6 py-4'>
        <a href='https://ahoy.ai'>
          <img
            src='/ahoy-logo-with-text-black.svg'
            alt='Ahoy'
            className='h-6 dark:invert'
          />
        </a>
      </header>

      {/* Main content */}
      <main className='flex-1 flex items-center justify-center'>
        <div className='text-center px-6'>
          <LinkBroken01
            aria-hidden='true'
            className='w-16 h-16 text-fg-quaternary mx-auto mb-4'
          />
          <h1 className='text-2xl font-semibold text-fg-primary mb-2'>
            This page is no longer available
          </h1>
          <p className='text-fg-secondary mb-6'>
            The owner may have changed access or deleted the chat.
          </p>
          <a
            href={isAuthenticated ? 'https://app.ahoy.ai' : 'https://ahoy.ai'}
            className='text-brand-primary hover:underline'
          >
            {isAuthenticated
              ? 'Go to your Ahoy dashboard'
              : 'Go to Ahoy homepage'}
          </a>
        </div>
      </main>
    </div>
  );
}
